import { ExclamationTriangleFill } from "react-bootstrap-icons";
import type {
  CommunicationLanguage,
  Interrogatory,
  ViewCommunicationItem,
} from "@/briefpoint-client";
import ReviewClientTaskBox from "./ReviewClientTaskBox";
import styles from "./ReviewClientTasksUnassignedSection.module.scss";

type ReviewClientTasksUnassignedListProps = {
  documentId: string;
  language: CommunicationLanguage;
  interrogatories: Interrogatory[];
  items: ViewCommunicationItem[];
  onDeleteItem: (id: string | undefined) => void;
  onOpenTaskEditor: (item: ViewCommunicationItem) => void;
};

export default function ReviewClientTasksUnassignedList(
  props: ReviewClientTasksUnassignedListProps,
) {
  return (
    <div className={styles.section}>
      <div>
        <div className={styles.headerRow}>
          <ExclamationTriangleFill
            style={{ color: "var(--feedback-warning-dark)" }}
          />
          <div className={styles.heading}>Unassigned Tasks</div>
        </div>
        <div className={styles.body}>
          The following items have no associated requests and won’t be visible
          to your client. Add at least one request to make them available.
        </div>
      </div>
      {props.items.map((externalCommunication) => (
        <ReviewClientTaskBox
          key={externalCommunication.id}
          communication={externalCommunication}
          language={props.language}
          interrogatories={props.interrogatories}
          documentId={props.documentId}
          setDeleteCommunication={(c) => {
            props.onDeleteItem(c.id);
          }}
          setEditCommunication={props.onOpenTaskEditor}
        />
      ))}
    </div>
  );
}
